/// <reference types="./authGetPrincipalsTotalCount.d.ts" />
export function autGetPrincipalsTotalCount(databaseAdapter, context) {
    return databaseAdapter.authGetPrincipalsTotalCount(context);
}
//# sourceMappingURL=authGetPrincipalsTotalCount.js.map